/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_LegalInputs */

const id_footer_legal = /** @type {(inputs: Footer_LegalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hukum`)
};

const ms_footer_legal = /** @type {(inputs: Footer_LegalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perundangan`)
};

const da_footer_legal = /** @type {(inputs: Footer_LegalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juridisk`)
};

const de_footer_legal = /** @type {(inputs: Footer_LegalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechtliches`)
};

const en_us2_footer_legal = /** @type {(inputs: Footer_LegalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legal`)
};

const es_es2_footer_legal = /** @type {(inputs: Footer_LegalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legal`)
};

const es_mx2_footer_legal = /** @type {(inputs: Footer_LegalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legal`)
};

const fil_footer_legal = /** @type {(inputs: Footer_LegalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legal`)
};

const fr_footer_legal = /** @type {(inputs: Footer_LegalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mentions légales`)
};

const it_footer_legal = /** @type {(inputs: Footer_LegalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Note legali`)
};

const hu_footer_legal = /** @type {(inputs: Footer_LegalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jogi nyilatkozat`)
};

const nl_footer_legal = /** @type {(inputs: Footer_LegalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juridisch`)
};

const no_footer_legal = /** @type {(inputs: Footer_LegalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juridisk`)
};

const pl_footer_legal = /** @type {(inputs: Footer_LegalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informacje prawne`)
};

const pt_br2_footer_legal = /** @type {(inputs: Footer_LegalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jurídico`)
};

const pt_footer_legal = /** @type {(inputs: Footer_LegalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legal`)
};

const ro_footer_legal = /** @type {(inputs: Footer_LegalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legal`)
};

const fi_footer_legal = /** @type {(inputs: Footer_LegalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lakiasiat`)
};

const sv_footer_legal = /** @type {(inputs: Footer_LegalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juridik`)
};

const vi_footer_legal = /** @type {(inputs: Footer_LegalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pháp lý`)
};

const tr_footer_legal = /** @type {(inputs: Footer_LegalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yasal`)
};

const cs_footer_legal = /** @type {(inputs: Footer_LegalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Právní informace`)
};

const bg_footer_legal = /** @type {(inputs: Footer_LegalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Правна информация`)
};

const ru_footer_legal = /** @type {(inputs: Footer_LegalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Правовая информация`)
};

const uk_footer_legal = /** @type {(inputs: Footer_LegalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Юридична інформація`)
};

const ar_footer_legal = /** @type {(inputs: Footer_LegalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قانوني`)
};

const hi_footer_legal = /** @type {(inputs: Footer_LegalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कानूनी`)
};

const th_footer_legal = /** @type {(inputs: Footer_LegalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กฎหมาย`)
};

const ja_footer_legal = /** @type {(inputs: Footer_LegalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`法的情報`)
};

const zh_cn2_footer_legal = /** @type {(inputs: Footer_LegalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`法律信息`)
};

const zh_hant1_footer_legal = /** @type {(inputs: Footer_LegalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`法律資訊`)
};

const ko_footer_legal = /** @type {(inputs: Footer_LegalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`법적 고지`)
};

/**
* | output |
* | --- |
* | "Legal" |
*
* @param {Footer_LegalInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const footer_legal = /** @type {((inputs?: Footer_LegalInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_LegalInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_footer_legal(inputs)
	if (locale === "ms") return ms_footer_legal(inputs)
	if (locale === "da") return da_footer_legal(inputs)
	if (locale === "de") return de_footer_legal(inputs)
	if (locale === "en-US") return en_us2_footer_legal(inputs)
	if (locale === "es-ES") return es_es2_footer_legal(inputs)
	if (locale === "es-MX") return es_mx2_footer_legal(inputs)
	if (locale === "fil") return fil_footer_legal(inputs)
	if (locale === "fr") return fr_footer_legal(inputs)
	if (locale === "it") return it_footer_legal(inputs)
	if (locale === "hu") return hu_footer_legal(inputs)
	if (locale === "nl") return nl_footer_legal(inputs)
	if (locale === "no") return no_footer_legal(inputs)
	if (locale === "pl") return pl_footer_legal(inputs)
	if (locale === "pt-BR") return pt_br2_footer_legal(inputs)
	if (locale === "pt") return pt_footer_legal(inputs)
	if (locale === "ro") return ro_footer_legal(inputs)
	if (locale === "fi") return fi_footer_legal(inputs)
	if (locale === "sv") return sv_footer_legal(inputs)
	if (locale === "vi") return vi_footer_legal(inputs)
	if (locale === "tr") return tr_footer_legal(inputs)
	if (locale === "cs") return cs_footer_legal(inputs)
	if (locale === "bg") return bg_footer_legal(inputs)
	if (locale === "ru") return ru_footer_legal(inputs)
	if (locale === "uk") return uk_footer_legal(inputs)
	if (locale === "ar") return ar_footer_legal(inputs)
	if (locale === "hi") return hi_footer_legal(inputs)
	if (locale === "th") return th_footer_legal(inputs)
	if (locale === "ja") return ja_footer_legal(inputs)
	if (locale === "zh-CN") return zh_cn2_footer_legal(inputs)
	if (locale === "zh-Hant") return zh_hant1_footer_legal(inputs)
	return ko_footer_legal(inputs)
});
export { footer_legal as "footer.legal" }